var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { Dependencies } from "~/core/decorator";
import FlieUpload from '~/components/common/file-upload.vue';
import { CarManageService } from '~/services/domain-service/car-manage.service';
var WarehousingAudit = /** @class */ (function (_super) {
    __extends(WarehousingAudit, _super);
    function WarehousingAudit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rules = {
            carApplyStatus: { required: true, message: '请选择审核结果' }
        };
        _this.dialogVisible = false;
        _this.dialogImageUrl = '';
        _this.fileList = [];
        _this.loading = false;
        _this.fromData = {
            carApplyStatus: '',
            remark: ''
        };
        return _this;
    }
    WarehousingAudit.prototype.emitClose = function () {
        this.reset();
    };
    WarehousingAudit.prototype.commit = function () {
        var _this = this;
        var from = this.$refs['ruleForm'];
        from.validate(function (valid) {
            if (!valid)
                return;
            _this.loading = true;
            _this.carManageService.warehouseApproval(__assign({ id: _this.rowData.id }, _this.fromData)).subscribe(function (data) {
                _this.loading = false;
                _this.$message.success('操作成功！');
                _this.emitClose();
            }, function (error) { _this.loading = false; });
        });
    };
    WarehousingAudit.prototype.imageFileList = function () {
        var _this = this;
        if (this.rowData.warehouseCarStatus !== 'IN_WAREHOUSE_WAIT_APPROVED')
            return;
        if (!this.rowData.imageIds)
            return;
        this.fileUploadService.getAllUploadFileByIds(this.rowData.imageIds).subscribe(function (data) {
            _this.fileList = data;
        });
    };
    WarehousingAudit.prototype.clickHandle = function (item) {
        this.dialogImageUrl = item.url;
        this.dialogVisible = true;
    };
    WarehousingAudit.prototype.reset = function () {
        var from = this.$refs['ruleForm'];
        from.resetFields();
        this.fileList = [];
    };
    __decorate([
        Prop()
    ], WarehousingAudit.prototype, "rowData", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], WarehousingAudit.prototype, "fileUploadService", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], WarehousingAudit.prototype, "carManageService", void 0);
    __decorate([
        Emit('close')
    ], WarehousingAudit.prototype, "emitClose", null);
    WarehousingAudit = __decorate([
        Component({
            components: {
                FlieUpload: FlieUpload
            }
        })
    ], WarehousingAudit);
    return WarehousingAudit;
}(Vue));
export default WarehousingAudit;
